module.exports = __webpack_public_path__ + "img/anchor-p1.d649644a.jpg";